<!-- 工具卡管理 -->
<template>
  <a-card :bordered="false">
    <!-- table区域-begin -->
    <div>
      <a-row :gutter="16">
        <a-col :span="22">
          <a-button style="float:right;" @click="onRefresh()">{{ $t('刷新') }}</a-button>
        </a-col>
        <a-col :span="2">
          <a class="download" @click="downloadFormWork()">{{ $t('下载插件') }}</a>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-card :title="$t('写卡操作')" :bordered="false">
            <a-form-item :label="$t('写卡类型')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="defaultCardType" style="width:100% ;" @change="handleChange">
                <a-select-option :value="item.key" v-for="item in cardTypeList" :key="item.key">
                  {{ $t(item.title) }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :label="$t('功能描述')">
              <a-textarea :readOnly="true" v-model="FunctionalDescription" :rows="8"></a-textarea>
            </a-form-item>
            <div v-if="defaultCardType==80">
              <a-form-model ref="formModel" :model="model" slot="detail" :colon="false" :rules="rules">
                <a-row :gutter="16">
                  <a-col :xl="12" :lg="7" :md="8" :sm="24">
                    <a-form-model-item :label="$t('用户卡号')" prop="userId" :labelCol="labelCol" :wrapperCol="wrapperCol"
                      style="width:260%;margin-right:10%;">
                      <a-input :placeholder="$t('请输入用户卡号')" v-model="model.userId" style="width:40%;margin-left:2px;">
                      </a-input>
                    </a-form-model-item>
                    <a-form-model-item :label="$t('充值次数')" prop="buyTimes" :labelCol="labelCol" :wrapperCol="wrapperCol"
                      style="width:260%;margin-right:10%;">
                      <a-input-number :placeholder="$t('请输入充值次数')" :min="1" v-model="model.buyTimes" :precision="0"
                        style="width:40%;margin-left:2px;"></a-input-number>
                    </a-form-model-item>
                    <a-form-model-item :label="$t('充值量')" prop="userAccount" :labelCol="labelCol" :wrapperCol="wrapperCol"
                      style="width:260%;margin-right:10%;">
                      <a-input-number :placeholder="$t('请输入充值量')" v-model="model.userAccount" :precision="0"
                        style="width:40%;margin-left:2px;"></a-input-number>
                      <div class="ant-input-number-suffix">{{ $t('分钟') }}</div>
                    </a-form-model-item>
                    <a-form-model-item :label="$t('计费开始时间')" prop="collectStartTime1" class="form-item-series">
                      <a-date-picker format="MM-DD" style="width:70%" v-model="model.collectStartTimeDay1" />
                      <a-select class="series-first-select" v-model="model.collectStartTime1" style="width: 30%;">
                        <a-select-option v-for="item in 24" :key="item" :value="item">{{item}}</a-select-option>
                      </a-select>
                    </a-form-model-item>
                    <a-form-model-item :label="$t('计费结束时间')" prop="collectEndTime1" class="form-item-series">
                      <a-date-picker format="MM-DD" style="width:70%" v-model="model.collectEndTimeDay1" />
                      <a-select class="series-first-select" v-model="model.collectEndTime1" style="width: 30%;">
                        <a-select-option v-for="item in 24" :key="item" :value="item">{{item}}</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-form-model>
            </div>
            <div v-else>
              <a-form-model ref="formModel" :model="model" slot="detail" :colon="false" :rules="rules">
              </a-form-model>
            </div>
            <div v-if="defaultCardType==4">
              <a-row :gutter="16">
                <a-col :xl="12" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('第一阶段用水价格')" :labelCol="labelCol" :wrapperCol="wrapperCol"
                    style="width:260%;margin-right:10%;">
                    <a-input-number :placeholder="$t('请输入第一阶段用水价格')" v-model="queryParam.meterId1" :step="0.1"
                      style="width:40%;margin-left:2px;"></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col :xl="12" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('计费类型')" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:220%;">
                    <a-select v-model="queryParam.top1" style="width:49%;">
                      <a-select-option :value="item.key" v-for="item in TheBillingTypeList" :key="item.key">
                        {{ $t(item.title) }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="12" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('报警金额')" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:260%;">
                    <a-input :placeholder="$t('请输入报警金额')" v-model="queryParam.meterId" style="width:40%;"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="12" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('最大透支金额')" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:220%;">
                    <a-input :placeholder="$t('请输入最大透支金额')" v-model="queryParam.meterId" style="width:49%;"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="12" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('单次购买最大金额')" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:260%;">
                    <a-input :placeholder="$t('请输入单次购买最大金额')" v-model="queryParam.meterId" style="width:40%;"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="12" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('最大囤积金额')" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:220%;">
                    <a-input :placeholder="$t('请输入最大囤积金额')" v-model="queryParam.meterId" style="width:49%;"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="12" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('预存金额')" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:260%;">
                    <a-input :placeholder="$t('请输入预存金额')" v-model="queryParam.meterId" style="width:40%;"></a-input>
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
            <a-button type="primary" @click="handleSubmit()">{{ $t('写卡') }}</a-button>
          </a-card>
        </a-col>
        <a-col :span="12">
          <a-card :title="$t('读卡操作')" :bordered="false">
            <a-form-item :label="$t('卡类型')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="cardTypeName" :readOnly="true" />
            </a-form-item>
            <a-form-item :label="$t('读取参数')">
              <a-textarea v-model="readResult" :readOnly="true" placeholder="" :rows="8" />
            </a-form-item>
            <a-button type="primary" @click="read_card()">{{ $t('读卡') }}</a-button>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import * as dayjs from "dayjs";
  import {
    fileUrl
  } from '@/utils/util'
  export default {
    name: 'MeterCaliberList',
    components: {},
    data() {
      const USB_DEF_RESULT = {
        10: '写卡失败',
        11: '写卡失败',
      }
      const CARD_TYPE_LIST = {
        30: '标准卡',
        31: '故障清除卡',
        32: '清零卡',
        33: '换表卡',
        34: '退水卡',
        35: '测试卡',
        36: '阀门卡',
        37: '超级阀门卡',
        38: '参数卡',
        39: '水编号卡',
        40: '水表校对卡',
        41: '校时卡',
        42: '临时充值卡',
        80: '用户卡'
      }
      const USB_DEF_INDEX = {
        //写卡成功
        USB_DEF_WRITESUCC: 10,
        // 写卡失败
        USB_DEF_WRITEFAIL: 11,
        // 读卡
        USB_DEF_READCARD: 21,
        // 标准卡
        USB_DEF_STANDCARD: 30,
        // 故障清除卡
        USB_DEF_FAILCLEAR: 31,
        // 清零卡
        USB_DEF_CLEARCARD: 32,
        // 换表卡
        USB_DEF_CHANGEMETER: 33,
        // 退水卡
        USB_DEF_BACKWATER: 34,
        // 测试卡
        USB_DEF_TESTCARD: 35,
        // 阀门卡
        USB_DEF_VALVECARD: 36,
        // 超级阀门卡
        USB_DEF_SUPERVALVE: 37,
        // 写参数卡
        USB_DEF_SETPARAM: 38,
        // 水钢印号卡
        USB_DEF_METERID: 39,
        // 水表校对卡
        USB_DEF_CHECKWATER: 40,
        // 校时卡
        USB_DEF_CHECKTIME: 41,
        // 临时充值卡
        USB_DEF_TMPPAYCARD: 42,
        // 开用户卡
        USB_DEF_MAKECARD: 80,
        //设置IP卡
        USB_DEF_IP: 44,
        // 充值
        USB_DEF_BUYGAS: 61,
        // 退卡中气，写标准卡，写用户卡
        USB_DEF_BACKCARD: 62,
        // 补卡标示
        USB_DEF_REPLACECARD: 63,
        // 是用户卡，确认写卡
        ERR_DEF_USRCARD: 220,
        // 页面标志
        USB_DEF_PAGEMARK: 240,
        // 页面激活标志
        USB_DEF_ACTIVEMARK: 241,
        // 充值界面的标志
        PAGE_MARK_BUYGAS: 1002,
        // 确认充值页面的标志
        PAGE_MARK_SHOWBUYGAS: 1003,
        // 补卡页面标识
        PAGE_MARK_REPLACE_CARD: 1004,
        // 退水卡页面标识
        PAGE_MARK_BACKWATER: 1005,
        // 退设备页面标识
        PAGE_MARK_BACKDEVICE: 1006,
        //用户开卡页面
        PAGE_MARK_MAKECARD: 1007,
        //用户退卡中水页面
        PAGE_MARK_BACKWATERCARD: 1008,
      };
      return {
        description: '工具卡管理页面',
        url: {},
        cardTypeList: [
          //{title: '标准卡',key: 30},
          //{title: '阀门卡',key: 36},
          {
            title: this.$t('用户卡'),
            key: 80
          }
        ],
        TheBillingTypeList: [{
            title: this.$t('按月'),
            key: 0
          },
          {
            title: this.$t('按季度'),
            key: 1
          },
          {
            title: this.$t('按年'),
            key: 2
          }
        ],
        queryParam: {

        },
        defaultCardType: 80,
        FunctionalDescription: '用户卡', //功能描述
        labelCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 3
          },
        },
        wrapperCol: {
          xs: {
            span: 24
          },
          sm: {
            span: 16
          },
        },
        wid: 101,
        socket: '',
        bconn: false,
        // lockReconnect:false,
        // 写卡成功
        USB_DEF_INDEX,
        USB_DEF_RESULT,
        CARD_TYPE_LIST,
        cardTypeName: '',
        model: {
          // userId: ''
        },
        readResult: '',
        url: {
          plugFileUrl: '/file/plugsetup.exe'
        }
      }
    },
    created() {
      this.connWebsocket();
    },
    computed: {
      // i18n：校验规则使用 computed 以响应语言切换
      rules() {
        return {
          userId: [{
            required: true,
            len: 12,
            message: this.$t('请输入正确的用户卡号')
          }],
          buyTimes: [{
            required: true,
            message: this.$t('请输入正确的购买次数')
          }],
          userAccount: [{
            required: true,
            message: this.$t('请输入正确的充值量')
          }],

          collectStartTime1: [{
            required: true,
            message: this.$t('请输入正确的计费开始时间')
          }],
          collectEndTime1: [{
            required: true,
            message: this.$t('请输入正确的计费开始时间')
          }],
        }
      }
    },
    methods: {
      // 连接socket
      connWebsocket() {
        try {
          this.socket = new WebSocket('ws://127.0.0.1:8753'); //复费率端口号为:8744
          // this.bconn = true;
        } catch (e) {
          alert('error');
          return;
        }
        this.socket.onopen = this.sOpen;
        this.socket.onerror = this.sError;
        this.socket.onmessage = this.sMessage;
        this.socket.onclose = this.sClose;
      },
      sOpen() {
        console.log("WebSocket连接成功");
        this.$message.success(this.$t("插件连接成功"));
        this.bconn = true;
        // 注册页面
        this.usb_do_deal(this.wid, this.socket, this.USB_DEF_PAGEMARK, this.wid);
      },
      sError(e) {
        console.log("WebSocket连接发生错误");
        // console.log(e);
        // const h = this.$createElement;
        // this.$info({
        //   title: this.$t('信息'),
        //   content: h('div', {}, [
        //     h('p', '写卡器连接出错'+ e),
        //   ]),
        //   onOk() {},
        // });
      },
      sMessage(msg) {
        console.log(msg.data);
        this.parseData(msg.data);
      },
      sClose(e) {
        console.log("-----接收消息-------" + e.code);
        // console.log(this.lockReconnect)
        this.bconn = false;
        this.reconnect();
      },
      reconnect() {
        var that = this;
        if (that.bconn) return;
        // that.lockReconnect = true;
        //没连接上会一直重连，设置延迟避免请求过多
        setTimeout(function () {
          console.info("尝试重连...");
          that.connWebsocket();
          // that.lockReconnect = false;
        }, 5000);
      },
      
     onRefresh(){
        // window.location.reload();
        this.$confirm({
          title: this.$t('刷新当前页面?'),
          content: h => <div style="color:red;">{this.$t('刷新当前页面重置当前页面，请确定是否进行刷新操作?')}</div>,
          onOk() {
            window.location.reload();
          },
          onCancel() {
          },
          class: 'test',
        });
      },
      
      parseData(data) {
        console.log(data);
        if (data == '') {
          return
        }
        let arr = data.split(',')
        this.cardTypeName = ''
        this.readResult = ''
        if (arr[0] == 36) {
          this.cardTypeName = this.$t(this.CARD_TYPE_LIST[Number(arr[0])])
        } else if (arr[0] == 80) {
          if (this.CARD_TYPE_LIST[Number(arr[0])]) {
            this.cardTypeName = this.$t(this.CARD_TYPE_LIST[Number(arr[0])])
          }
          if (arr[2] == -1) {
            // 校验和错误
            this.readResult = this.$t(`请重新去水表刷卡`)
            return;
          }
          if (arr[2] == 1) {
            this.readResult =
              `${this.$t('用户卡号：')}${arr[1]}\n${this.$t('刷卡标识：')}${arr[2] == 1?this.$t('已刷卡'):this.$t('未刷卡')}\n${this.$t('充值次数：')}${arr[3]}\n${this.$t('累计开阀时长：')}${arr[4]}${this.$t('分钟')}\n${this.$t('刷卡日期：')}${arr[5]}${this.$t('年')}${arr[6]}${this.$t('月')}${arr[7]}${this.$t('日')}`
          } else {
            this.readResult =
              `${this.$t('用户卡号：')}${arr[1]}\n${this.$t('刷卡标识：')}${arr[2] == 1?this.$t('已刷卡'): this.$t('未刷卡')}\n${this.$t('购买次数：')}${arr[3]}\n${this.$t('充值量：')}${arr[4]}${this.$t('分钟')}\n${this.$t('计费起始时间：')}${arr[5]}${this.$t('月')}${arr[6]}${this.$t('日')}${arr[7]}${this.$t('时')}\n${this.$t('计费结束时间：')}${arr[8]}${this.$t('月')}${arr[9]}${this.$t('日')}${arr[10]}${this.$t('时')}`
          }
        }else if (arr[0] == 10) {
            console.log("写卡成功")
          this.$message.success(this.$t("写卡成功"));
        }else if (arr[0] == 11) {
          this.$message.error(this.$t("写卡失败"));
        } else {
          if (this.CARD_TYPE_LIST[Number(arr[0])]) {
            this.cardTypeName = this.$t(this.CARD_TYPE_LIST[Number(arr[0])])
          }
        }
        console.log(this.cardTypeName);
        console.log(this.readResult);
      },
      handleChange(value) {
        console.log(value)
        this.FunctionalDescription = this.$t(this.CARD_TYPE_LIST[value])
      },
      usb_do_deal(mark, socket, flags, wparam) {
        // 对数据进行组合
        console.log("song");
        var data = flags + "," + mark + "," + wparam;
        socket.send(data);
      },
      usb_do_checkWebSocket(bconn) {
        if (!bconn) {
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('写卡器连接错误，请确保插件正常运行后，刷新页面重试!')),
            ]),
            onOk() {},
          });
        }
        return bconn;
      },
      //读卡
      read_card() {
        if (!this.usb_do_checkWebSocket(this.bconn)) {
          return;
        }
        console.log("hah");
        this.usb_do_deal(this.wid, this.socket, this.USB_DEF_INDEX.USB_DEF_READCARD, '');
      },
      handleSubmit() {
        if (!this.usb_do_checkWebSocket(this.bconn)) {
          return;
        }
        this.$refs.formModel.validate(valid => {
          if (valid) {
            this.write_card()
          }
        })
      },
      //写卡
      write_card() {
        var index = this.defaultCardType
        switch (parseInt(index)) {
          case 30:
            // 标准卡
            this.usb_do_deal(this.wid, this.socket, this.USB_DEF_INDEX.USB_DEF_STANDCARD, '');
            break;
          case 36:
            // 阀门卡
            this.usb_do_deal(this.wid, this.socket, this.USB_DEF_INDEX.USB_DEF_VALVECARD, '');
            break;
          case 80:
            //用户卡
            let params = ''
            console.log(this.model)
            let collectStartTime1 = this.model.collectStartTime1
            let collectEndTime1 = this.model.collectEndTime1

            let collectStartTimeDay1 = dayjs(this.model.collectStartTimeDay1).format('MMDD')
            let collectEndTimeDay1 = dayjs(this.model.collectEndTimeDay1).format('MMDD')
            collectStartTime1 = this.model.collectStartTime1.toString().padStart(2, '0')
            collectEndTime1 = this.model.collectEndTime1.toString().padStart(2, '0')
            let buyDate = collectStartTime1 +','+collectStartTimeDay1.substr(2,2)+','+collectStartTimeDay1.substr(0,2)+','
            +collectEndTime1 +','+collectEndTimeDay1.substr(2,2)+','+collectEndTimeDay1.substr(0,2)
            params = this.model.userId + ',' + this.model.buyTimes + ',' + this.model.userAccount + ',' + buyDate
            console.log(params)
            this.usb_do_deal(this.wid, this.socket, this.USB_DEF_INDEX.USB_DEF_MAKECARD, params);
            break;
        }
      },
      handleExportFile(url, fileName) {
        console.log(url, fileName)
        if (!fileName || typeof fileName != "string") {
          fileName = this.$t("导出文件")
        }
        url = `${fileUrl}${url}`
        console.log(url)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
      },
      downloadFormWork() {
        let fileName = 'plugsetup.exe'
        this.handleExportFile(this.url.plugFileUrl, fileName)
      }
    }
  }
</script>
<style scoped>
  .download {
    font-size: 16px;
    display: block;
    color: red;
    text-align: right;
  }

  .ant-form>>>.ant-input-number-affix .ant-input-number {
    width: calc(100% - 50px);
  }

  .ant-input-number-suffix {
    display: inline-block;
    width: 50px;
    text-align: left;
    padding-left: 3px;
  }

  @import '~@assets/less/common.less';
</style>